const ClearUser = () => {
  localStorage.removeItem("LogedUser")
}
export default ClearUser
